export const FEATURES = {
    default: [
        {
            title: "Undetectable",
            description: "Invisible during screen sharing on meeting apps such as Zoom(web), Google Meet, etc."
        },
        {
            title: "Real-Time",
            description: "Get fast answers in just 1 second, tested under 500 Mb network"
        },
        {
            title: "Personalized",
            description: "Get personalized advice with examples tailored to your experience."
        }
    ],
    assistant: [
        {
            title: "Screen-Aware",
            description: "It can both listen for coding questions and capture the screen if a LeetCode-style question is being screen shared with you."
        },
        {
            title: "Real-Time",
            description: "Get fast answers in just 1 second, tested under 500 Mb network"
        },
        {
            title: "Personalized",
            description: "Get personalized advice with examples tailored to your experience."
        }
    ]
};
